import { Box } from "@mui/material";
import Text from "../../../../components/ui/Text";

export const PayDirectly = () => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        borderRadius: "8px",
        p: 2, // 16px padding
        mb: 3,
        border: "1px solid #E5E5E5",
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Text variant="paragraph" sx={{ fontWeight: 600 }}>
          Payment details
        </Text>
      </Box>
      <Box
        sx={{
          p: 2,
          backgroundColor: "#D2F0FF",
          border: "1px solid #54B2FF",
          borderRadius: "6px",
        }}
      >
        <Text variant="paragraph">Pay the host directly</Text>
        <Box sx={{ mt: 1 }}>
          <Text variant="paragraph3" sx={{ color: "#666" }}>
            Pay the total amount to the host in cash on the day or through their
            payment link provided after you join.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
